import React, { useEffect, useState } from "react";
import Button from "@mui/material/Button";
import EditIcon from "@mui/icons-material/Edit";
import DeleteIcon from "@mui/icons-material/Delete";
import DownloadIcon from "@mui/icons-material/Download";
import Snackbar from "@mui/material/Snackbar";
import Alert from "@mui/material/Alert";
import moment from "moment";
import { useDispatch, useSelector } from "react-redux";
import "./Contact.scss";
import Controls from "../Controls";
import ContactForm from "./contactform/ContactForm";
import DeleteContact from "./deletecontact/DeleteContact";
import Popup from "../../../../../components/Popup/Popup";
import defaultImg from "../../../../../assets/img/defaultImg.jpg";
// import { RenderCellExpand } from "../../../../../components/datagridtooltip/DataGridToolTip";
import EditPermissionForm from "./editpermissionform/EditPermissionForm";
import { API_URL_ADMIN, API_URL_LMS } from "../../../../../Constant/index";
import Axios from "axios";
import { Grid } from "@mui/material";
// import {
//   DataGrid,
//   GridToolbarContainer,
//   GridToolbarColumnsButton,
//   GridToolbarQuickFilter,
//   GridToolbarExport,
//   GridToolbarDensitySelector,
// } from "@mui/x-data-grid";
import { RenderCellExpand } from "../../../../../components/datagridtooltip/DataGridToolTip";
import { getSubDealerContactAction } from "../../../../../_actions/subDealer.action";
import ExportPopup from "../../../../../components/exportPopup/ExportPopup";
import ExportExcelPopup from "../../../../../components/exportPopup/ExportExcelPopup";
import DataGridProMUI from "../../../../../components/DataGrid/DataGridProMUI";
import {
  DATE_FORMAT,
  DATE_TIME_FORMAT,
  millisecondsToStringDate,
} from "../../../../../_helpers/commonFunctions";
import { onExportExcel } from "../../../../../_helpers/exportExcel";
import AuthorizedMessagePage from "../../../../../components/AuthorizedMessagePage";
import AuthLoader from "../../../../../components/AuthLoader";
import { authorizedMessage, isPermission } from "../../../../../_helpers/commonAPI";
import { ToastContainer, toast } from 'react-toastify';

const Contact = () => {
  const search = window.location.search;
  const params = new URLSearchParams(search);
  const subdealerNumber = params.get("subDelearNumber");
  const subdealerName = params.get("subDelearName");
  const [openPopup, setOpenPopup] = useState(false);
  const [openEditPermissionPopup, setOpenEditPermissionPopup] = useState(null);
  const [openDeleteContactPopup, setOpenDeleteContactPopup] = useState(null);
  const [openExportPopup, setOpenExportPopup] = useState(null);
  const [recordForEdit, setRecordForEdit] = useState(null);
  const [recordForDelete, setRecordForDelete] = useState({});
  const [recordForEditPermission, setRecordForEditPermission] = useState(null);
  const [headerName, setHeaderName] = useState("Add Contact");
  const [rows, setRows] = useState([]);
  const [gridData, setGridData] = useState([]);
  const [pageSize, setPageSize] = useState(25);
  const [searchedRows, setSearchedRows] = useState(null)
  const [state, setState] = React.useState({
    message: "Deleted Successfully!!!!",
    severity: "success",
    open: false,
    editPermissionHdr: "",
  });
  const excelFormating = [{ dateOfBirth: "date" }];
  const excelDataTransformConfig = {
    markDelete: { true: "Yes", false: "No" },
    pdpaSigned: { true: "Yes", false: "No" },
  };
  const dispatch = useDispatch();
  const subDealerContactState = useSelector((state) => state.subDealerContact);
  const [fileUrl, setFileUrl] = useState("");
  const [exportFiles, setExportFiles] = useState([])
  const [open, setOpen] = useState(false);
  const [exportState, setExportState] = useState("Export");
  const [statusCode, setStatusCode] = useState(null)
  // const CustomToolbar = () => {
  //   return (
  //     <GridToolbarContainer className="CntGridToolbarContainer">
  //       <Grid container spacing={2}>
  //         <Grid item md={4} xs={12}>
  //           <GridToolbarColumnsButton />
  //           <GridToolbarDensitySelector />
  //         </Grid>
  //         <Grid item md={4} xs={6}>
  //           <Grid container spacing={2}>
  //             <div className="ContactExportAndSearchContainer">
  //               <Grid item md={4} xs={12}>
  //                 <Button
  //                   variant="outlined"
  //                   startIcon={<DownloadIcon />}
  //                   onClick={onExportClick}
  //                 >
  //                   {exportState.btnName}
  //                 </Button>
  //               </Grid>
  //               <Grid item md={12} xs={12}>
  //                 <GridToolbarQuickFilter />
  //               </Grid>
  //             </div>
  //           </Grid>
  //         </Grid>
  //       </Grid>
  //     </GridToolbarContainer>
  //   );
  // };

  useEffect(() => {
    dispatch(getSubDealerContactAction(subdealerNumber));
  }, []);
  useEffect(() => {
    if (!openPopup && !openDeleteContactPopup && !openEditPermissionPopup) {
      dispatch(getSubDealerContactAction(subdealerNumber));
    }
  }, [openPopup, openDeleteContactPopup, openEditPermissionPopup]);

  // const onExportClick = () => {
  //   setExportState({ btnName: "Exporting..." });
  //   const requestOptions = {
  //     headers: {
  //       "Content-Type": "application/json",
  //       "X-AUTH-TOKEN": localStorage.getItem("x-auth-token"),
  //     },
  //   };
  //   Axios.get(
  //     API_URL_ADMIN +
  //       `retailer/exportSubDealerContacts?subDealerNumber=` +
  //       subdealerNumber
  //   )
  //     .then((response) => {
  //       setOpenExportPopup(true);
  //       setExportState({ btnName: "EXPORT", linkToDownload: response.data });
  //     })
  //     .catch((error) => {
  //       setExportState({ btnName: "EXPORT" });
  //     });
  // };

  const onExportClick = () => {
    const url = `export/contact-report`;
    setExportState("Exporting...")
    Axios({
      method: "POST",
      url: API_URL_ADMIN + url,
      data: { "subDealerCode": subdealerNumber },
      headers: {
        "Content-Type": "application/json",
        "X-AUTH-TOKEN": localStorage.getItem("x-auth-token"),
        "X-SOLD-TO-ID": localStorage.getItem("CustomerNumber"),
      },
    })
      .then(async (response) => {
        setExportState("Export");
        setOpen(true);
        setFileUrl(response.data.data);
        exportExcelFile(response.data.data);
      })
      .catch((err) => { setExportState("Export"); });
  }

  function exportExcelFile(file_url) {
    setExportFiles([])
    Axios({
      method: "GET", url: API_URL_ADMIN + `export/bucket?folderName=${file_url}`,
      headers: {
        "Content-Type": "application/json",
        'X-AUTH-TOKEN': localStorage.getItem('x-auth-token'),
        'X-SOLD-TO-ID': localStorage.getItem('CustomerNumber')
      }
    })
      .then(async (response) => {
        const newRes = Array.isArray(response.data.data) ? response.data.data : []
        setExportFiles(newRes)
      }).catch((err) => {
        // setExportState({ btnName: "EXPORT" });
      })
  }

  const columns = [
    {
      field: "actions",
      headerName: "Actions",
      headerAlign: "center",
      renderCell: (params) => {
        const findSelectedObj = () => {
          const api = params.api;
          const selectedRow = {};
          api
            .getAllColumns()
            .filter((c) => c.field !== "__check__" && !!c)
            .forEach(
              (c) =>
                (selectedRow[c.field] = params.getValue(params.id, c.field))
            );
          const selectedObject = rows.find(
            (item) => item.userName == selectedRow.userName
          );
          return selectedObject;
        };
        const onEditClick = async (e) => {
          let selectedObj = params.row;
          const isAllow = await isPermission("RetailerSubDealerManagement-Contact-edit")
          if (!isAllow) {
            toast.success(authorizedMessage, {
              position: toast.POSITION.TOP_RIGHT
            });
            return 0;
          }
          setHeaderName("Edit Contact");
          setRecordForEdit(selectedObj);
          setOpenPopup(true);
        };
        const onDeleteClick = async (e) => {
          let selectedObj = params.row;
          const isAllow = await isPermission("RetailerSubDealerManagement-Contact-delete")
          if (!isAllow) {
            toast.success(authorizedMessage, {
              position: toast.POSITION.TOP_RIGHT
            });
            return 0;
          }
          setRecordForDelete(selectedObj);
          setOpenDeleteContactPopup(true);
        };
        return (
          <>
            {params.row.deleted ? null : (
              <div className="Action">
                <EditIcon
                  className="EditIcon"
                  onClick={onEditClick}
                  sx={{ cursor: "pointer" }}
                />
                <DeleteIcon
                  className="DeleteIcon"
                  onClick={onDeleteClick}
                  sx={{ cursor: "pointer" }}
                />
              </div>
            )}
          </>
        );
      },
    },
    {
      field: "markDelete",
      headerName: "Mark Delete",
      renderCell: (markDelete) => {
        return (
          <div className="MarkDelChkBox">
            <Controls.Checkbox value={markDelete.row.markDelete} />
          </div>
        );
      },
    },
    {
      field: "permissions",
      headerName: "Permissions",
      headerAlign: "center",
      renderCell: (params) => {
        const onClick = (e) => {
          setRecordForEditPermission(params.row);
          setState({
            editPermissionHdr: "Permissions for " + params.row.userName,
          });
          setOpenEditPermissionPopup(true);
        };
        return (
          <Button onClick={onClick} disabled={params.row.markDelete}>
            Edit
          </Button>
        );
      },
    },
    {
      field: "userName",
      headerName: "User Name",
      headerAlign: "center",
      align: "center",
      width: 200,
      renderCell: (row) => <RenderCellExpand align="center" {...row} />,
    },
    {
      field: "contactImage",
      headerName: "User Image",
      headerAlign: "center",
      align: "center",
      width: 150,
      renderCell: (row) => {
        return (
          <img
            className="user_image"
            src={row.formattedValue ? row.formattedValue : defaultImg}
          ></img>
        );
      },
    },
    {
      field: "firstName",
      headerName: "First Name",
      headerAlign: "center",
      width: 200,
      renderCell: RenderCellExpand,
    },
    {
      field: "lastName",
      headerName: "Last Name",
      headerAlign: "center",
      width: 200,
      renderCell: RenderCellExpand,
    },
    {
      field: "nickName",
      headerName: "Nick Name",
      headerAlign: "center",
      width: 200,
      renderCell: RenderCellExpand,
    },
    {
      field: "mobileNumber",
      headerName: "Mobile Number",
      width: 150,
      headerAlign: "center",
      align: "center",
    },
    {
      field: "phoneNumber",
      headerName: "Phone Number",
      width: 150,
      headerAlign: "center",
      align: "center",
    },

    {
      field: "emailAddress",
      headerName: "Email Address",
      width: 200,
      headerAlign: "center",
      align: "center",
      renderCell: (row) => <RenderCellExpand align="center" {...row} />,
    },
    {
      field: "gender",
      headerName: "Gender",
      headerAlign: "center",
      align: "center",
    },
    {
      field: "dobString",
      headerName: "Date of Birth",
      headerAlign: "center",
      width: 100,
      // renderCell: ({ row }) => {
      //   return (
      //     <div>
      //       {row.dateOfBirth
      //         ? moment(row.dateOfBirth).format("DD-MM-yyyy")
      //         : null}
      //     </div>
      //   );
      // },
    },
    {
      field: "age",
      headerName: "Age",
      headerAlign: "center",
      align: "center",
    },
    {
      field: "maritalStatus",
      headerName: "Marital Status",
      headerAlign: "center",
      align: "center",
      width: 120,
    },
    {
      field: "relation",
      headerName: "Relation",
      headerAlign: "center",
      align: "center",
    },
    {
      field: "position",
      headerName: "Position",
      headerAlign: "center",
      align: "center",
    },
    {
      field: "highestEducation",
      headerName: "Highest Education",
      headerAlign: "center",
      align: "center",
      width: 150,
    },
    {
      field: "institution",
      headerName: "Institution",
      headerAlign: "center",
      align: "center",
    },
    {
      field: "major",
      headerName: "Major",
      headerAlign: "center",
      align: "center",
    },
    {
      field: "notPreferedFood",
      headerName: "Not Preferred Food",
      headerAlign: "center",
      align: "center",
      width: 150,
    },
    {
      field: "notPreferedDrink",
      headerName: "Not Preferred Drink",
      headerAlign: "center",
      align: "center",
      width: 150,
    },
    {
      field: "dietaryLimitaion",
      headerName: "Dietary Limitation",
      headerAlign: "center",
      align: "center",
      width: 150,
    },
    {
      field: "favoriteSports",
      headerName: "Favorite Sports",
      headerAlign: "center",
      align: "center",
      width: 150,
    },
    {
      field: "country",
      headerName: "Country",
      headerAlign: "center",
      align: "center",
    },
    {
      field: "handicap",
      headerName: "Handicap",
      headerAlign: "center",
      align: "center",
      renderCell: ({ row }) => {
        return (
          <div className="MarkDelChkBox">
            <Controls.Checkbox value={row.handicap === true ? true : false} />
          </div>
        );
      },
    },
    {
      field: "whatsAppId",
      headerName: "WhatsApp Id",
      headerAlign: "center",
      align: "center",
      renderCell: RenderCellExpand,
    },
    {
      field: "zoloId",
      headerName: "Zolo Id",
      headerAlign: "center",
      align: "center",
      renderCell: RenderCellExpand,
    },
    {
      field: "lineId",
      headerName: "Line Id",
      headerAlign: "center",
      align: "center",
      renderCell: RenderCellExpand,
    },
    {
      field: "pdpaSigned",
      headerName: "PDPA Signed",
      headerAlign: "center",
      align: "center",
      width: 150,
      renderCell: ({ row }) => {
        return (
          <div className="MarkDelChkBox">
            <Controls.Checkbox value={row.pdpaSigned === "true"} />
          </div>
        );
      },
    },
    {
      field: "pdpaSignedDate",
      headerName: "PDPA Signed Date & Time",
      width: 250,
      headerAlign: "center",
      align: "center",
    },
  ];

  React.useEffect(() => {
    const gridData =
      subDealerContactState &&
      subDealerContactState.subdealerContactList &&
      subDealerContactState.subdealerContactList.data &&
      subDealerContactState.subdealerContactList.data.map((item, index) => {
        return {
          ...item,
          dobString: millisecondsToStringDate(item.dateOfBirth, DATE_FORMAT),
        };
      });
    setGridData(gridData);
    const sCode = subDealerContactState && subDealerContactState.errorMessage && subDealerContactState.errorMessage.status
    setStatusCode(sCode)
  }, [subDealerContactState]);


  function modifyColumns(columns) {
    // columns = columns.filter(function (el) { return el.field != "actions" || el.field != "permissions"; });
    columns = columns.filter((item) => !["actions", "permissions"].includes(item.field));
    return columns.map((item) => {
      return ({
        label: item.headerName,
        value: item.field,
        ...item
      })
    })
  }

  function modifyRows(rowdata) {
    // let filteredRow = searchedRows.map((item) => item.model);
    let filteredRow = rowdata.map((item) => item.model);
    const data = filteredRow.map((item) => {
      return ({
        ...item,
        dobString: item.dateOfBirth ? new Date(item.dateOfBirth) : ""
      })
    })
    return data
  }

  function callExcelExport(data) {
    const fileName = `SUBDEALER_CONTACT_${moment(new Date()).format("DDMMyyyy")}`;
    const sheetName = `CONTACTS`
    onExportExcel(modifyColumns(columns), modifyRows(data), fileName, sheetName)
  }

  return (
    <>

      {subDealerContactState.loading ? <AuthLoader /> : statusCode === 401 ? <AuthorizedMessagePage /> :
        <>
          <Snackbar
            anchorOrigin={{ vertical: "top", horizontal: "right" }}
            open={state.open}
            autoHideDuration={6000}
            key={"topright"}
          >
            <Alert
              severity={state.severity}
              sx={{ width: "100%" }}
              action={
                <Button
                  color="inherit"
                  size="small"
                  onClick={() => {
                    setState({ open: false });
                  }}
                >
                  Close
                </Button>
              }
            >
              {state.message}
            </Alert>
          </Snackbar>
          <div className="ContactContainer">
            <div className="AddAndSearch">
              <Button
                variant="contained"
                className="AddContactBtn"
                onClick={async() => {
                  const isAllow = await isPermission("RetailerSubDealerManagement-Contact-AddContact-create")
                  if (!isAllow) {
                    toast.success(authorizedMessage, {
                      position: toast.POSITION.TOP_RIGHT
                    });
                    return 0;
                  }
                  setHeaderName("Add Contact");
                  setOpenPopup(true);
                  setRecordForEdit(null);
                }}
              >
                ADD CONTACT
              </Button>
            </div>
          </div>
          <div className="ContactDataGridContainer">
            <ExportExcelPopup
              title={"Customer"}
              fileName={"customer"}
              setOpen={setOpen}
              open={open}
              exportExcelFile={exportExcelFile}
              fileUrl={fileUrl}
              exportFiles={exportFiles}
            />
            <DataGridProMUI
              rows={gridData ? gridData : []}
              //pageSize={25}
              // rowsPerPageOptions={[25, 50, 75, 100]}
              columns={columns}
              pageSize={pageSize}
              onPageSizeChange={(newPageSize) => setPageSize(newPageSize)}
              // components={{
              //   Toolbar: CustomToolbar,
              // }}
              // componentsProps={{
              //   toolbar: {
              //     showQuickFilter: true,
              //     quickFilterProps: { debounceMs: 500 },
              //   },
              // }}

              // ExportDateFormatIndexes={[10]}
              loading={subDealerContactState.loading}
              onExportClick={onExportClick}
              exportState={exportState}
              setSearchedRows={setSearchedRows}
              callExcelExport={callExcelExport}
              defaultStateChange={false}
            />
          </div>
          {/* popup is a reusable custom dialog component, pt pb pr pl are padding props*/}
          <Popup
            title={headerName}
            openPopup={openPopup}
            setOpenPopup={setOpenPopup}
            width={"100%"}
            height={"100%"}
            pt={0}
            pb={0}
            pl={0}
            pr={0}
          >
            <ContactForm
              setOpenPopup={setOpenPopup}
              recordForEdit={recordForEdit}
            />
          </Popup>
          <Popup
            title={state.editPermissionHdr}
            openPopup={openEditPermissionPopup}
            setOpenPopup={setOpenEditPermissionPopup}
          >
            <EditPermissionForm
              openPopup={openEditPermissionPopup}
              setOpenPopup={setOpenEditPermissionPopup}
              recordForEditPermission={recordForEditPermission}
            />
          </Popup>
          <Popup
            title={""}
            openPopup={openDeleteContactPopup}
            setOpenPopup={setOpenDeleteContactPopup}
          >
            <DeleteContact
              openPopup={openDeleteContactPopup}
              setOpenPopup={setOpenDeleteContactPopup}
              recordForDelete={recordForDelete}
              setState={setState}
            />
          </Popup>
          {/* <ExportPopup
        title={""}
        openPopup={openExportPopup}
        setOpenExportPopup={setOpenExportPopup}
        linkToDownload={exportState.linkToDownload}
      /> */}
        </>
      }
    </>
  );
};

export default Contact;
